// CountdownDisplay.js or a similar file name
import React from "react";
import { FormattedMessage } from "react-intl"; // Assuming you're using react-intl for i18n
import PropTypes from "prop-types";

const CountdownDisplay = ({ timeLeft, styles }) => {
  return (
    <div className={styles.timeLeft}>
      <p className={styles.timeLeftTitle}>
        <FormattedMessage id="room-entry-modal.time-left" defaultMessage="The Verse will open in:" />
      </p>

      <div className={styles.humanTimeLeft}>
        {timeLeft.days !== "00" && (
          <div>
            <h3>{timeLeft.days}</h3>
            <p>
              <FormattedMessage
                id="room-entry-modal.days"
                defaultMessage="{days}"
                values={{ days: timeLeft.days === "01" ? "day" : "days" }}
              />
            </p>
          </div>
        )}

        {timeLeft.hours !== "00" && (
          <div>
            <h3>{timeLeft.hours}</h3>
            <p>
              <FormattedMessage
                id="room-entry-modal.hours"
                defaultMessage="{hours}"
                values={{ hours: timeLeft.hours === "01" ? "hour" : "hours" }}
              />
            </p>
          </div>
        )}

        <div>
          <h3>{timeLeft.minutes}</h3>
          <p>
            <FormattedMessage
              id="room-entry-modal.minutes"
              defaultMessage="{minutes}"
              values={{ minutes: timeLeft.minutes === "01" ? "minute" : "minutes" }}
            />
          </p>
        </div>

        {timeLeft.days === "00" && ( // Updated condition to correctly check for non-zero seconds
          <div>
            <h3>{timeLeft.seconds}</h3>
            <p>
              <FormattedMessage
                id="room-entry-modal.seconds"
                defaultMessage="{seconds}"
                values={{ seconds: timeLeft.seconds === "01" ? "second" : "seconds" }}
              />
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

CountdownDisplay.propTypes = {
  // Add time left as object with days hours minutes and seconds
  timeLeft: PropTypes.shape({
    days: PropTypes.string,
    hours: PropTypes.string,
    minutes: PropTypes.string,
    seconds: PropTypes.string
  }),
  styles: PropTypes.object.isRequired
};

export default CountdownDisplay;
